export const SHOPIFY_RATE_LINK =
  "https://apps.shopify.com/jubilee/reviews?ratings%5B%5D=5#modal-show=WriteReviewModal";
